module.exports = __webpack_public_path__ + "static/media/46guerreiros.e084a9c7.mp3";